import Name from "_shared/names/name";
import Password from "users/auth/credentials/passwords/password";

export default class AcceptEntityUserInvitationAPIRequest {
  public readonly password: string;
  public readonly confirmPassword?: string;
  public readonly firstName?: string;
  public readonly lastName?: string;
  public readonly isClient?: boolean;
  public readonly isVendor?: boolean;

  public constructor(password: Password, name: Name, isClient?: boolean, isVendor?: boolean) {
    this.password = password.value;
    this.confirmPassword = password.value;
    this.firstName = name.firstName;
    this.lastName = name.lastName;
    this.isClient = isClient;
    this.isVendor = isVendor;
  }
}
